export default __webpack_public_path__ + "866bbb7a13a33d21b3636d06b2342ae7.ttf";